import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PostLoginResponse } from '../interfaces/post-login';
import { RequestError } from '../../../interfaces/error.interface';
import { PostGoogleLoginResponse } from '../interfaces/post-google-login';
import { PostSignUpResponse } from '../interfaces/post-sign-up';
import { PostGoogleSyncResponse } from '../interfaces/post-google-sync';

export interface AuthState {
  token: string | null;
  refreshToken: string | null;
  errorCode: number | null;
}

const initialState: AuthState = {
  token: null,
  refreshToken: null,
  errorCode: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    postLoginInitApiAction: (state) => {
      state.errorCode = null;
    },
    postLoginSuccessApiAction: (
      state,
      action: PayloadAction<PostLoginResponse>
    ) => {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
    },
    postLoginFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    postSignUpInitApiAction: (state) => {
      state.errorCode = null;
    },
    postSignUpSuccessApiAction: (
      state,
      action: PayloadAction<PostSignUpResponse>
    ) => {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
    },
    postSignUpFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    postGoogleLoginInitApiAction: (state) => {
      state.errorCode = null;
    },
    postGoogleLoginSuccessApiAction: (
      state,
      action: PayloadAction<PostGoogleLoginResponse>
    ) => {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
    },
    postGoogleLoginFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    postGoogleSyncInitApiAction: (state) => {
      state.errorCode = null;
    },
    postGoogleSyncSuccessApiAction: (
      state,
      action: PayloadAction<PostGoogleSyncResponse>
    ) => {},
    postGoogleSyncFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    authClearAction: (state) => {
      state.token = null;
      state.refreshToken = null;
      state.errorCode = null;
    },
  },
});

export const {
  postLoginInitApiAction,
  postLoginSuccessApiAction,
  postLoginFailureApiAction,
  postSignUpInitApiAction,
  postSignUpSuccessApiAction,
  postSignUpFailureApiAction,
  postGoogleLoginInitApiAction,
  postGoogleLoginSuccessApiAction,
  postGoogleLoginFailureApiAction,
  postGoogleSyncInitApiAction,
  postGoogleSyncSuccessApiAction,
  postGoogleSyncFailureApiAction,
  authClearAction,
} = authSlice.actions;

export default authSlice.reducer;
